import { AST } from '@handlebars/parser';
import { isNull, isDefined, isBoolean, isString } from 'utils/tsHelpers';

import { createStringLiteral } from './createStringLiteral';
import { createNumberLiteral } from './createNumberLiteral';
import { createBooleanLiteral } from './createBooleanLiteral';
import { createNullLiteral } from './createNullLiteral';
import { createUndefinedLiteral } from './createUndefinedLiteral';
import { isHandlebarNumber } from './isHandlebarNumber';

export const createLiteral = <T>(value?: T): AST.Literal => {
  if (isString(value)) return createStringLiteral(value);
  if (isHandlebarNumber(value)) return createNumberLiteral(value);
  if (isBoolean(value)) return createBooleanLiteral(value);
  if (isNull(value)) return createNullLiteral();
  if (!isDefined(value)) return createUndefinedLiteral();
  throw new Error("can't create literal");
};
